const video1 = document.querySelector('#box3-1-video')
const video2 = document.querySelector('#box3-2-video')
const video4 = document.querySelector('#box3-4-video')
const video5 = document.querySelector('#box3-5-video')
const box3SlidesLi = document.querySelectorAll('#box3-splide .splide__list li');
const box4text = document.querySelector('.box4-img .text')
const box8Video = document.querySelectorAll('.box8-video .video video')
const box8Item = document.querySelectorAll('.box8-video .video .item')
const box9Video = document.querySelector('#box9-video')
const box9Img1 = document.querySelector('.box9-video-img .img1')
const box9Img2 = document.querySelector('.box9-video-img .img2')
const box10Video = document.querySelector('#box10-video')
const box10Img1 = document.querySelector('.box10-video-img .img1')
const box10Img2 = document.querySelector('.box10-video-img .img2')

const box3Splide = new Splide('#box3-splide', {
  perPage    : 2,
  perMove    : 1,
  focus  : 'center',
  trimSpace  : false,
  arrows : false,
  drag : false,
  gap: '30px',
  breakpoints: {
    1700: {
      perPage: 1.5,
      gap: '18px',
    },
    750: {
      perPage: 1.25,
      gap: '15px',
      drag : true
    }
  }
}).mount();

const box9Splide = new Splide('#box9-splide', {
  perPage: 1,
  gap: '20px'
}).mount();

new Splide('#box13-splide', {
  type   : 'loop',
  perPage: 2.5,
  focus  : 'center',
  lazyLoad: 'nearby',
  breakpoints: {
    1920: {
      perPage: 2,
      pagination: true
    },
    750: {
      perPage: 1,
      pagination: true,
      gap:'10px'
    }
  }
}).mount(); 

ScrollTrigger.matchMedia({
  "(min-width: 750px)": function() {

    video1.load()
    video2.load()
    video4.load()
    video5.load()

    ScrollTrigger.create({
      trigger: '.box3',
      start: 'top 35%',
      scrub: true,
      once: true,
      onEnter(){
        video_anime()
      }
    })

    ScrollTrigger.create({
      trigger: '.box9',
      start: 'top bottom',
      scrub: true,
      once: true,
      onEnter(){
        box9Video.load()
        box10Video.load();
      }
    })
    
    ScrollTrigger.create({
      trigger: '.box10',
      start: 'top 40%',
      scrub: true,
      once: true,
      onEnter(){

      let playPromise10 = box10Video.play();

      if (playPromise10 !== undefined) {
        playPromise10.then(_ => {

          box10Video.addEventListener('timeupdate', () => {
            box10Img1.classList.add('is');
          });
      
          box10Video.addEventListener('ended', () => {
            box10Video.classList.add('is');
            box10Img2.classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }    
        
      }
    })

    function video_anime(){
      const text = document.querySelector('.splide__slide .item1 .text1')
      const video = document.querySelector('#box3-1-video')
      const img1 = document.querySelector('.splide__slide .item1 .video-img1')
      const img2 = document.querySelector('.splide__slide .item1 .video-img2')

      let playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.then(_ => {

          img1.classList.add('is');
          video.addEventListener('timeupdate', () => {
            if (video.currentTime >= 2.5) {
              text.classList.add('is');
            }
          });
          video.addEventListener('ended', () => {
            img2.classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }  
      
    }

    box3SlidesLi.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        box3Splide.go(index); // 切换到点击的 Slide
      });
    });

    // 添加监听事件
    box3Splide.on('move', () => {
      const activeIndex = box3Splide.index;
      click_video_anime(activeIndex)
    });

    box9Splide.on('move', () => {
      const activeIndex = box9Splide.index;
      video9_anime(activeIndex)
    });
    
    
  },
  "(max-width: 750px)": function() {

  }
})



ScrollTrigger.create({
  trigger: '.box4',
  start: 'top 30%',
  scrub: true,
  once: true,
  onEnter(){
    box4text.classList.add('active');
  }
})

ScrollTrigger.create({
  trigger: '.box8',
  start: 'top 30%',
  scrub: true,
  once: true,
  onEnter(){

    box8Video.forEach((item)=>{
      item.load();

      item.addEventListener('canplaythrough', () => {
        item.play();
        box8Item.forEach((item)=>{
          item.classList.add('is');
        })
      });

    })
  }
})


function video9_anime(index){

  box9Video.classList.remove('is');
  box9Img1.classList.remove('is');
  box9Img2.classList.remove('is');

  box9Video.currentTime = 0;
  box9Video.pause();

  if(index == 1){
    setTimeout(() => {

      box9Video.classList.add('is');
      box9Img1.classList.add('is');

      let playPromise9 = box9Video.play();

      if (playPromise9 !== undefined) {
        playPromise9.then(_ => {

          box9Video.addEventListener('ended', () => {
            box9Video.classList.remove('is');
            box9Img2.classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      } 
      
    }, 300);
  }
  
}

function click_video_anime(index){

    const text = document.querySelectorAll('.splide__slide .item .text')
    const itemImg = document.querySelectorAll('.splide__slide .item .item-img')
    const img1 = document.querySelectorAll('.splide__slide .item .video-img1')
    const img2 = document.querySelectorAll('.splide__slide .item .video-img2')

    text.forEach((item) => item.classList.remove('is'));
    itemImg.forEach((item) => item.classList.remove('is'));
    img1.forEach((item) => item.classList.remove('is'));
    img2.forEach((item) => item.classList.remove('is'));

    video1.currentTime = 0;
    video2.currentTime = 0;
    video4.currentTime = 0;
    video5.currentTime = 0;
    video1.pause();
    video2.pause();
    video4.pause();
    video5.pause();


    if(index + 1 === 1){

      let playPromise1 = video1.play();

      if (playPromise1 !== undefined) {
        playPromise1.then(_ => {

          video1.addEventListener('timeupdate', () => {
            img1[index].classList.add('is');
            if (video1.currentTime >= 2.5) {
              text[index].classList.add('is');
            }
          });
          video1.addEventListener('ended', () => {
            itemImg[index].classList.add('is');
            img2[index].classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }
      
    }

    if(index + 1 === 2){

      let playPromise2 = video2.play();
      if (playPromise2 !== undefined) {
        playPromise2.then(_ => {

          video2.addEventListener('timeupdate', () => {
            img1[index].classList.add('is');
            if (video2.currentTime >= 3.5) {
              text[index].classList.add('is');
            }
          });

          video2.addEventListener('ended', () => {
            itemImg[index].classList.add('is');
            img2[index].classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }

    }

    if(index + 1 === 3){
      setTimeout(() => {
        text[index].classList.add('is');
      }, 300);
    }

    if(index + 1 === 4){

      let playPromise4 = video4.play();

      if (playPromise4 !== undefined) {
        playPromise4.then(_ => {

          video4.addEventListener('timeupdate', () => {
            img1[index-1].classList.add('is');
            if (video4.currentTime >= 1.2) {
              text[index].classList.add('is');
            }
          });
          video4.addEventListener('ended', () => {
            itemImg[index-1].classList.add('is');
            img2[index-1].classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }

    }

    if(index + 1 === 5){

      let playPromise5 = video5.play();
      if (playPromise5 !== undefined) {
        playPromise5.then(_ => {

          video5.addEventListener('timeupdate', () => {
            img1[index-1].classList.add('is');
            if (video5.currentTime >= 0.6) {
              text[index].classList.add('is');
            }
          });
          video5.addEventListener('ended', () => {
            itemImg[index-1].classList.add('is');
            img2[index-1].classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }   

    }
  
}

$('.video-but').click(function(){
  
  const videoWidth = $(this).context.dataset.width;
  const videoHeight = $(this).context.dataset.height;
  const videoSrc = $(this).context.dataset.src;

  $(this).parent().css('z-index','1')
  
  let videoCode =`<iframe width="${videoWidth}" height="${videoHeight}" src="https://www.youtube.com/embed/${videoSrc}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`

  $(this).parent().next().append(videoCode);
})
